<template>
  <div class="list-group-item">
    <div class="list-group-item-figure">
      <div class="tile tile-img">
        <span class="fas fa-file-pdf fa-lg text-red"></span>
      </div>
    </div>
    <div class="list-group-item-body" :class="{ 'border-none': noBorder }">
      <div class="media align-items-center">

        <div class="media-body">
          <a target="_blank"
             :href="`/${file.path}`"
             :title="file.name">
             {{ file.name }}
             <span v-if="file.from_amendment" class="badge badge-success badge-sm">Enmienda</span>
             <span v-else class="badge badge-info badge-sm">Original</span>
            </a>
          <small class="text-muted d-block">{{ formattedDate }}</small>
        </div>

        <div class="media-actions">
          <a href="#"
             class="btn btn-sm btn-secondary"
             type="button"
             @click.prevent="$emit('delete-file', file)"
             v-if="!readonly">Eliminar
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'FileItem',
    props: {
      file: {
        type: Object,
        required: true,
        default: null,
      },
      noBorder: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        readonly: 'protocols/readonly',
      }),

      formattedDate() {
        return moment(this.file.created_at).format('DD/MM/YYYY')
      },
    },
  }
</script>
